<div *ngIf="!isLoading">
  <div class="btn-list">
    <div class="blocked" *ngIf="projeto?.can_full_block || projeto?.can_meta_block">
      <div class="full" (click)="bloqueioProjeto(true)" *ngIf="projeto?.can_full_block" tooltip="Bloqueio Total" placement="bottom">
        <img src="assets/images/svgs/Bloquear-total.svg" alt="Bloqueio Total" *ngIf="projeto?.full_blocked">
        <img src="assets/images/svgs/Desbloquear-total.svg" alt="Desbloqueio Total" *ngIf="!projeto?.full_blocked">
      </div>
      <div class="meta" (click)="bloqueioProjeto()" *ngIf="projeto?.can_meta_block" tooltip="Bloqueio Meta" placement="bottom">
        <img src="assets/images/svgs/Bloquear-meta.svg" alt="Bloqueio Meta" *ngIf="projeto?.meta_blocked">
        <img src="assets/images/svgs/Desbloquear-meta.svg" alt="Desbloqueio Meta" *ngIf="!projeto?.meta_blocked">
      </div>
    </div>
    <div class="btn-icon">
      <img src="assets/images/svgs/Imprimir.svg" (click)="openPrintModal()" alt="Imprimir" tooltip="Imprimir" placement="bottom">
    </div>
    <div class="btn-icon" *ngIf="permissions?.edit_check">
      <a routerLink="/projetos/projeto/{{idProjeto}}/cadastro/editar">
        <img src="assets/images/svgs/Editar.svg" alt="Editar" tooltip="Editar" placement="bottom">
      </a>
    </div>
    <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
  </div>

  <div class="info-page">
    <h3>Projeto</h3>
  </div>
  <div class="list-info">
    <h4>Projeto:</h4>
    <p class="destaque">{{maskProjeto}} - {{ projeto?.title }}</p>
  </div>

  <div class="list-info">
    <h4>Órgão responsável:</h4>
    <p>{{ projeto?.agency_name }}</p>
  </div>

  <div class="list-info">
    <h4> Vigência do projeto:</h4>
    <p>{{ projeto?.full_dt }}</p>
  </div>

  <div class="list-info">
    <h4>Valor total previsto:</h4>
    <p>{{ projeto?.value }}</p>
  </div>

  <div class="list-info">
    <h4>Status:</h4>
    <p>{{ projeto?.status }}</p>
  </div>

  <div class="list-info">
    <h4>Gerente:</h4>
    <p>{{ projeto?.resp_nome }}</p>
  </div>

  <div class="list-info">
    <h4>Gerentes Adjuntos:</h4>
    <p>{{ projeto?.resp_adj | formatNameList }}</p>
  </div>

  <div class="list-info">
    <h4>Ativo:</h4>
    <p>{{ projeto?.str_actived }}</p>
  </div>

  <div class="list-info">
    <h4>Estratégico:</h4>
    <p>{{ projeto?.level_priority_label }}</p>
  </div>

  <div class="list-info">
    <h4>Início Previsto:</h4>
    <p>{{ projeto?.dt_foreseen_start }}</p>
  </div>

  <div class="list-info">
    <h4>Término Previsto:</h4>
    <p>{{ projeto?.dt_foreseen_end }}</p>
  </div>

  <div class="info-page m-t-mdx">
    <h3>Escopo</h3>
  </div>

  <div class="list-info" *ngIf="projeto?.description">
    <h4>Descrição do Projeto</h4>
    <p>{{ projeto?.description }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.ds_reason">
    <h4>Justificativa</h4>
    <p>{{ projeto?.ds_reason }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.ds_goal">
    <h4>Objetivo do projeto</h4>
    <p>{{ projeto?.ds_goal }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.ds_target">
    <h4>Público-alvo</h4>
    <p>{{ projeto?.ds_target }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.ds_requirements">
    <h4>Requisitos</h4>
    <p>{{ projeto?.ds_requirements }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.ds_assumptions">
    <h4>Premissas</h4>
    <p>{{ projeto?.ds_assumptions }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.ds_restrictions">
    <h4>Restrições</h4>
    <p>{{ projeto?.ds_restrictions }}</p>
  </div>

  <div class="info-page m-t-lg">
    <h3>Informações específicas</h3>
  </div>

  <div class="list-info" *ngIf="projeto?.monitor">
    <h4> Assessor de Governança:</h4>
    <p>{{ projeto?.monitor }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.irfe">
    <h4>Irfe:</h4>
    <p>{{ projeto?.irfe }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.ircp">
    <h4>Ircp:</h4>
    <p>{{ projeto?.ircp }}</p>
  </div>

  <div class="list-info" *ngIf="projeto?.agregate">
    <h4>Programa/Projeto Agregador:</h4>
    <p>
      <span *ngFor="let agr of projeto?.agregate">
        {{ agr.title }}<br>
      </span>
    </p>
  </div>
</div>

<ng-template #modalPrint>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Impressão de Relatório</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closePrintModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Tipo de Relatório</label>
        <input type="hidden" name="filter_year_code" [value]="filter_year_code">
        <ng-select id="report_type" class="ng-select-alternative" [items]="reportList" [(ngModel)]="report_type" bindLabel="label" bindValue="id" [clearable]="false">
        </ng-select>
      </div>
    </div>

    <div class="form-group row" *ngIf="report_type == 2">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Análise</label>
        <ng-select id="report_2_param_2" class="ng-select-alternative" [items]="analiseList" [(ngModel)]="report_2_param_2"
          bindLabel="label" bindValue="id" [clearable]="false">
        </ng-select>
      </div>
    </div>

    <div class="form-group row" *ngIf="report_type == 2">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Tipo Análise</label>
        <ng-select id="report_2_param_1" class="ng-select-alternative" [items]="tipoAnaliseList" [(ngModel)]="report_2_param_1" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Nenhum">
        </ng-select>
      </div>
    </div>

    <div class="form-group row" *ngIf="report_type == 3">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Info</label>
        <ng-select id="report_3_param_1" class="ng-select-alternative" [items]="infoList" [(ngModel)]="report_3_param_1" [multiple]="true" bindLabel="label" bindValue="id" placeholder="Nenhum">
        </ng-select>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closePrintModal()">Fechar</button>
        <button class="btn btn-primary" type="button" (click)="imprimirProjetos()">Imprimir</button>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading || isLoadingBlock"></app-loading>
